export const categoryDMP = {
  Ekonomi: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=finance', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=economyreader'],
  Finans: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=finance', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=economyreader'],
  Yaşam: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=nature'],
  Sağlık: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=health', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Health Insurance'],
  Yemek: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Yemek Tarifleri', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=food'],
  Seyahat: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=travel', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Travel Insurance'],
  Teknoloji: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Technology%20interest',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Technology Buyers',
  ],
  'Genel Kültür': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Arts%20and%20Culture'],
  Gaming: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Gamer', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=E Sports'],
  'Nasıl yapılır?': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Do It Yourself - DIY'],
  'Dizi & Film': [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Online%20Dizi',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Movies',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=TV%20Dizileri',
  ],
  TV: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=TV%20Dizileri'],
  Magazin: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Magazine', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=celebrities'],
  Goygoy: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Magazine'],
  Eğitim: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Education'],
  Spor: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Sports'],
  Test: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=tests'],
  Vitrin: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=E-commerce', 'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Shopping'],
  Yazio: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=News - Yazio'],
  Video: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=video'],
  Gündem: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=News'],
  Döviz: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Financial Markets'],
  'Altın Fiyatları': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Financial Markets'],
  Borsa: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Financial Markets'],
  Kredi: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Potantial Loanee',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Bank Loan',
  ],
  'Kripto Para': [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Cyrpto',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Financial Markets',
  ],
  Sigorta: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Auto Insurance',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Health Insurance',
  ],
  Girişimcilik: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=entrepreneurship'],
  İlişkiler: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=In%20A%20Relationship'],
  'Anne Bebek': [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Anne - Baba',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Yeni Anne',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Anne',
  ],
  Güzellik: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Make Up',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Personal Care',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=beauty',
  ],
  Moda: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Clothes',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Fashion',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=style',
  ],
  Hayvanlar: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Pet%20Owners',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Dog%20Owners',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Cat%20Owners',
  ],
  Otomobil: [
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Car%20Owners',
    'https://dmp.adform.net/dmp/profile/?pid=10548&sg=Tend%20To%20Buy%20A%20New%20Car%20Soon',
  ],
  Astroloji: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=astrology'],
  'Cinsel Sağlık': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Sexual Health'],
  Atıştırmalık: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Snack'],
  Diyet: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Diet'],
  Vegan: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Vegetarian'],
  Tatlı: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Dessert'],
  'Ürün İncelemeleri': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Product Review'],
  'Donanım & Yazılım': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Technology%20interest'],
  'Yapay Zeka': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Technology%20interest'],
  Tarih: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Historical%20Moments'],
  Müzik: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=music'],
  Sanat: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Arts%20and%20Culture'],
  Kitap: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=books'],
  'Ünlüler Dosyası': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=celebrities'],
  KPSS: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=University Graduate'],
  ALES: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=University Graduate'],
  DGS: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Pre University'],
  LGS: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Pre University Student'],
  YKS: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=Pre University Student'],
  Futbol: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=football'],
  Basketbol: ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=basketball'],
  'E-Spor': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=E%20Sports'],
  'Astroloji Testleri': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=astrology'],
  'İlişki Testleri': ['https://dmp.adform.net/dmp/profile/?pid=10548&sg=In%20A%20Relationship'],
};
